import { delay } from "@/hooks/useReveal";
import { BookingLink } from "./BookingLink";

const PROGRAMMES = [
  ["For everyone", "AI basics and productivity", "Hands-on training with ChatGPT, Claude and the tools your team already has, for people starting from zero."],
  ["For CEOs, CFOs and legal", "AI governance for leaders", "How to run AI in your organisation: roles, policy, risk and vendors."],
  ["For whole teams", "AI Act literacy", "The Article 4 training every company using AI must provide, delivered so people actually apply it."],
];

export const Academy = () => (
  <section id="academy" className="section section--white" aria-labelledby="academy-title" data-testid="academy-section">
    <div className="container">
      <div className="stack section-head" data-reveal>
        <p className="eyebrow">AI Arena Academy</p>
        <h2 id="academy-title" className="title">Prefer to build the skills in-house? We teach that too.</h2>
        <p className="lead">Practical programmes for teams and leaders, from first prompts to the AI literacy the AI Act requires.</p>
      </div>
      <div className="programmes section-body">
        {PROGRAMMES.map(([kicker, title, text], i) => (
          <article className="programme" key={title} data-reveal style={delay(i)} data-testid={`programme-card-${i + 1}`}>
            <p className="kicker">{kicker}</p>
            <h3 className="programme__title">{title}</h3>
            <p className="programme__text">{text}</p>
          </article>
        ))}
      </div>
      <div className="academy__cta" data-reveal>
        <BookingLink className="btn btn--navy" testId="academy-cta">Ask about a programme</BookingLink>
      </div>
    </div>
  </section>
);
